import { NotificationSeverity } from '../services/notifier';
import { Notification } from './notification';

export class NotificationInfo extends Notification {
  protected severity: NotificationSeverity = 'info';
}
